import { styled, Box } from "@mui/material";

export const ColorWheelRoot = styled(Box)(({ theme }) => ({
  width: 150,
  height: "auto",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  gap: "1rem",
  transition: "all ease-in-out 0.5s, width 0.3s ease",
  padding: "0 0 0.25rem 0",
  position: "relative",
  marginLeft: 5,
  [theme.breakpoints.up("md")]: {
    gap: "1rem",
    width: 150,
  },
  [theme.breakpoints.up("xl")]: {
    gap: ".8rem",
    width: 150,
  },
  "& .color-hue": {
    flexGrow: 1,
    flexShrink: 1,
    width: "100% !important",
    height: "25px !important",
    [theme.breakpoints.up("lg")]: {
      height: "30px !important",
    },
    "& .w-color-alpha-fill": {
      width: "0.5rem!important",
      height: "calc(25px + 6px)!important",
      transform: "translate(0, -3px)!important",
      borderRadius: "5px!important",
      background: "#282823 !important",
      [theme.breakpoints.up("md")]: {
        height: "calc(30px + 6px)!important",
      },
    },
  },
  "& .color-saturation": {
    flexGrow: 0,
    flexShrink: 0,
    width: "100% !important",
    height: "25px !important",
    [theme.breakpoints.up("md")]: {
      height: "30px !important",
    },
    "& .w-color-alpha-fill": {
      transform: "translate(-3px, -3px)!important",
    },
  },
}));
